"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

require("./timeline.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Timeline = function Timeline(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('timeline', className)
  }, children);
};

Timeline.propTypes = {
  children: _propTypes["default"].node,
  className: _propTypes["default"].string
};
Timeline.defaultProps = {
  children: null,
  className: null
};
var _default = Timeline;
exports["default"] = _default;